import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogComplimentaryConfigurationComponent } from './change-log-complimentary-configuration.component';

@NgModule({
  declarations: [ChangeLogComplimentaryConfigurationComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogComplimentaryConfigurationComponent],
})
export class ChangeLogComplimentaryConfigurationModule {}
